import Vue from 'vue'
import Lottie from 'vue-lottie/src/lottie.vue'
Vue.component('Lottie', Lottie)
